export default __webpack_public_path__ + "static/media/graphic2.eb5e2103.svg";